import { PLAYER_COLORS } from '../theme/themes';
import type { Player } from '../types/game';

const DEFAULT_PLAYER_COLORS = [...PLAYER_COLORS];

export function pickNextPlayerColor(used: Set<string>): string {
  const next = DEFAULT_PLAYER_COLORS.find((c) => !used.has(c));
  if (next) return next;
  return DEFAULT_PLAYER_COLORS[used.size % DEFAULT_PLAYER_COLORS.length];
}

export function assignPlayerColors(players: Player[]): Player[] {
  const used = new Set<string>();
  const normalized = players.map((p) => {
    const existing = p.color || '';
    const hasValid = existing && DEFAULT_PLAYER_COLORS.includes(existing as (typeof DEFAULT_PLAYER_COLORS)[number]);
    const chosen = hasValid && !used.has(existing) ? existing : pickNextPlayerColor(used);
    used.add(chosen);
    return { ...p, color: chosen };
  });
  return normalized;
}

export function readableTextColor(bg: string): string {
  // Prosty kontrast: luminancja względna
  const hex = bg.replace('#', '');
  if (hex.length !== 6) return '#0B1021';
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;
  const lum = 0.299 * r + 0.587 * g + 0.114 * b;
  return lum > 0.6 ? '#0B1021' : '#F8FBFF';
}

export function getPlayerColor(player?: Player, index?: number): string {
  if (player?.color) return player.color;
  const idx = typeof index === 'number' ? index : 0;
  return DEFAULT_PLAYER_COLORS[idx % DEFAULT_PLAYER_COLORS.length];
}
